module.exports = __webpack_public_path__ + "static/testimonial_bg_two-508d6210a3eff3050dffec0fd69c4357.png";